import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine, { DimensionLineType } from "@/Models/Lines/DimensionLine";

export class SlopedRightRectangleFlipVertical extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'sloped-right-rectangle-flip-vertical', dimensions );
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width_bottom;
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidthTop(): Length {
		return this.cleanedPrimitives.width_top;
	}

	getWidthBottom(): Length {
		return this.cleanedPrimitives.width_bottom;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'width_top', tertiary: 'width_bottom' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		const prefix = focusedElement.includes("cutout_measurement") && !forceRender ? 'cutout_' : '';

		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [0, this.getHeight().in_mm()], this.renderDimensionLabel( 'height' ), [-40, 0], ratio, `${prefix}measurements-sloped-right-rectangle-height` === focusedElement ? DimensionLineType.primary : DimensionLineType.default ),
				new DimensionLine( [0, this.getHeight().in_mm()], [this.getWidthTop().in_mm(), this.getHeight().in_mm()], this.renderDimensionLabel( 'width_top' ), [0, 40], ratio, `${prefix}measurements-sloped-right-rectangle-width_top` === focusedElement ? DimensionLineType.primary : DimensionLineType.default ),
				new DimensionLine( [0, 0], [this.getWidthBottom().in_mm(), 0], this.renderDimensionLabel( 'width_bottom' ), [0, -40], ratio, `${prefix}measurements-sloped-right-rectangle-width_bottom` === focusedElement ? DimensionLineType.primary : DimensionLineType.default ),
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height: 50,
			width_top: 25,
			width_bottom: 50,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			width_top: width.divide(3).in_cm(),
			width_bottom:width.divide(2).in_cm(),
			height: height.divide(2).in_cm(),
		};
	}
}
